module.exports = __webpack_public_path__ + "static/media/close-icon.1e990667.svg";